/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 10/1/20
 * Time: 12:49 PM
 */
export const QUESTION_BANK_ROUTE_PATH = "/event/question-bank/883fe2d7576c488a7ff67eebc079fbfe96dc844b82a30759c7be836e5d3c2955";
export const GUEST_ROUTE_PATH = "/guest";
export const NOTIFICATION_ROUTE_PATH = "/notification-panel";
export const EVENT_APP_REDIRECTION_ROUTE_PATH = "/v";
export const PARK_APP_REDIRECTION_ROUTE_PATH = "/p";
export const EVENT_APP_DOWNLOAD_ROUTE_PATH = "/event-app";
export const PARK_APP_DOWNLOAD_ROUTE_PATH = "/park-app";
export const PUBLIC_CORPORATE_SIGNUP = "/public/corporate-registration";
export const PUBLIC_THANK_YOU_PAGE = "/public/thank-you";
export const PUBLIC_WEB_SIGN_UP_PAGE = "/public/web-sign-up";
export const PUBLIC_WEB_SIGN_IN_PAGE = "/public/web-sign-in";
export const PUBLIC_WEB_USER_DETAILS = "/public/user-details";
export const MD_QR_VIEW_R = "/q";
export const MD_QR_VIEW = "/qr";

// HR ROUTE
export const HR_ROUTE_PATH = "/human-resources";

// CHANGE VEHICLE NUMBER - VISITORTAGS/PARKTAGS
export const CHANGE_VEHICLE_NUMBER_ROUTE_PATH = "/visitor/change-vehicle";

// HOST
export const HOST_ROUTE_PATH = "/host";

// BRANCH QR ROUTE
export const VISITOR_BRNACH_QR_URL = `${window.location.origin}/guest?b=`;
